import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Upload,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const EditProduct = ({
  open,
  close,
  setLoading,
  getProductList,
  selectedData,
  categoryList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      name:
        selectedData.product_image !== null
          ? selectedData.product_image
          : "default-logo.png",
      status: "done",
      url:
        selectedData.product_image !== null
          ? `${process.env.REACT_APP_API_IMAGE}products/${selectedData.product_image}`
          : require("./../../../assets/empty.png"),
    },
  ]);

  const handleEditUnit = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    formdata.append("image", values.file === undefined ? "" : values.file.file);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/edit-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited product successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              product: "",
              description: "",
              category: "",
              price: "",
            });
            setLoadings(false);
            setLoading(false);
            getProductList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleChange = (info) => {
    // console.log(info);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    // console.log("fileList", fileList);
    setFileList(fileList);
  };

  return (
    <Drawer
      title="Edit Product"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="basic"
          initialValues={{
            product: selectedData.product,
            description: selectedData.description,
            category: parseInt(selectedData.category),
            price: selectedData.price,
          }}
          onFinish={handleEditUnit}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="file"
              rules={[
                {
                  required: false,
                  message: "Product image required",
                },
              ]}
            >
              <Upload
                beforeUpload={({ fileList: newFileList }) => {
                  // setFileList(newFileList);
                  return false;
                }}
                fileList={fileList}
                onChange={handleChange}
                multiple={false}
                listType="picture-card"
                maxCount={1}
                // defaultFileList={[]}
                showUploadList={{
                  showRemoveIcon: false,
                }}
                // fileList={fileList}
              >
                {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
                Upload
              </Upload>
            </Form.Item>

            <Form.Item
              name="product"
              label="Product Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input
                placeholder="Set product name"
                size="large"
                // value={selectedData.product}
                // defaultValue={selectedData.product.toString()}
              />
            </Form.Item>

            <Form.Item name="description" label="Product Description">
              <Input
                placeholder="Set product description"
                size="large"
                // value={selectedData.description}
                // defaultValue={selectedData.description.toString()}
              />
            </Form.Item>

            <Form.Item
              name="category"
              label="Category"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select category"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {categoryList.data.length > 0 ? (
                  categoryList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.category}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No category found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="price"
              label="Price"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                // value={selectedData.price}
                // defaultValue={selectedData.price.toString()}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditProduct;
